<template>
  <ResetPassword/>
</template>

<script>
import ResetPassword from "@/components/Authentication/ResetPassword/ResetPassword";

export default {
  name: "ForgotPasswordPage",
  components: {ResetPassword}
};
</script>

<style scoped>

</style>